import script from "./TranscriptPoll.vue?vue&type=script&setup=true&lang=ts"
export * from "./TranscriptPoll.vue?vue&type=script&setup=true&lang=ts"

import "./TranscriptPoll.vue?vue&type=style&index=0&id=e07045aa&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e07045aa"]])

export default __exports__